// @flow
// TODO(mauricio): rename this component to something more meaningful, it
// represents a route that can't be accessed because there's not enough data to
// render it (i.e. dealer settings is pending)
import { connect } from 'react-redux';

import ProtectedRoute from './ProtectedRoute';
import type { StateProps } from './ProtectedRoute';

import type { State } from 'store/State';
import { isPrivateRoute } from 'store/reducers/userInteractions/selectors';

const mapStateToProps = (state: State): StateProps => ({
  isEnabled: isPrivateRoute(state)
});

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/common/router/PrivateRoute.js